import React, { useEffect, useState, useCallback }  from 'react';
import './choose_method.css';
import { useSelector } from 'react-redux';
import PoiOption from './PoiOption'
import 'react-datepicker/dist/react-datepicker.css';
import { useHistory } from "react-router-dom";
import { get } from "../common/api";
import { Link } from "react-router-dom";


function FromBucketlist() {
    const [bucketlists, setBucketlists] = useState([]);
    const auth = useSelector(state => state.auth);
    const [itin, setItin] = useState([]);
    const [conflict, setConflict] = useState(false);
    const [message, setMessage] = useState('');
    const history = useHistory();

    const isInvalidRange = useCallback((value) => {
      if (value['start_time'].getTime() >= value['end_time'].getTime()){
        console.log(conflict)
        setConflict(true)
        setMessage("Jam mulai harus lebih awal dari Jam selesai")
      }
    }, [conflict])

    const timeOverlap = useCallback((rangeA, rangeB) => {
      let startA = rangeA['start_time'].toString()
      let endA   = rangeA['end_time'].toString()
      let startB = rangeB['start_time'].toString()
      let endB   = rangeB['end_time'].toString()

      return startA.localeCompare(endB) < 0 &&
             startB.localeCompare(endA) < 0;
    }, [])

    const checkOverlap = useCallback((array) => {
      for (let i = 0; i < array.length; i++) {
        for (let j = i+1; j < array.length; j++){
          if (timeOverlap(array[i], array[j])) {
            setConflict(true)
            setMessage("Jadwal Anda bentrok")
          }
        }
      }
    }, [timeOverlap])

    const checkConflictAll = useCallback((value) => {
      setConflict(false);
      itin.forEach(isInvalidRange);
      checkOverlap(itin);
    }, [checkOverlap, isInvalidRange, itin])

    const getBucketlists = useCallback(async () => {
      const token = auth.token;
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      if (token) {
        config.headers['Authorization'] = `Token ${token}`;
      }

      try {
        const res = await get("/api/bucket-list/", config);
        const results = res.data;
        const bl = results.map((result) => ({
          ...result.poi,
          start_time: new Date(),
          end_time: new Date(),
        }));
        setBucketlists(bl);
      }
      catch (err) {
        console.log(err);
      }
    }, [auth.token])

    useEffect(() => {
        getBucketlists();
        checkConflictAll();
    }, [itin, auth, checkConflictAll, getBucketlists]);

    function transformToItinDetailFormat(bucketListItem) {
      const wibFormatter = new Intl.DateTimeFormat('id', { dateStyle: 'full', timeStyle: 'short' });
      return {
        id: bucketListItem.id,
        start_time: wibFormatter.format(bucketListItem.start_time),
        end_time: wibFormatter.format(bucketListItem.end_time),
        poi: {
          ...bucketListItem,
        },
      };
    }

    const createItin = async () => {

        if (conflict === true){
          setMessage("Masih terdapat bentrok pada jadwal Anda")}
        else {

          itin.sort(function(a, b) {
            var keyA = Date.parse(a.start_time),
            keyB = Date.parse(b.start_time);
            console.log(keyA, keyB)
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });

          const itinPoiList = itin.map(transformToItinDetailFormat);
          history.push("/itin/create/finalize", { itinPoiList });
      }
    }

  return (
    <div className="fb container-sm">
         <div className="d-flex justify-content-center text-center profile-title">
              <p className="h4">Pilih dari Bucket List</p>
        </div>
        {/* <DatePicker selected={startDate} onChange={date => setStartDate(date)} /> */}
        <div className="bucketlists">
        {bucketlists.map((poi) => <PoiOption key={poi.id} {...poi} itin={itin} setItin={setItin} checkConflict={checkConflictAll}/> )}
        </div>
        <div className="d-flex justify-content-center warn">
        {conflict && <h4 className="mt-3">{message} !</h4>}
        </div>
        
        <div className="d-flex justify-content-center mt-4">
        <Link to="/itin/create" className="button-outline button">Batal</Link>
            <div className="button-filled button" onClick={createItin}>
                Buat ITIN
            </div>
        </div>
      </div>
  );
}

export default FromBucketlist;

